import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "df-summary" };
const _hoisted_2 = { class: "df-summary__row" };
const _hoisted_3 = { class: "df-summary__muted" };
const _hoisted_4 = { class: "df-summary__value" };
const _hoisted_5 = {
    key: 0,
    class: "df-summary__row"
};
const _hoisted_6 = { class: "df-summary__value" };
const _hoisted_7 = { class: "df-summary__row df-summary__row--total" };
const _hoisted_8 = { class: "df-summary__total-label" };
const _hoisted_9 = { class: "df-summary__total" };
import { computed } from "vue";
import { useDonation } from "../../context/donationContext";
import { useChrome } from "../../i18n/useChrome";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSummary',
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const { amountMinor, formatMinor, frequency, frequencySuffixToken, projectOptions, state, } = useDonation();
        const { tf } = useChrome();
        const frequencyLabel = computed(() => tf(`frequency.${frequency.value}`));
        const suffix = computed(() => frequencySuffixToken.value ? ` ${tf(`frequency.suffix.${frequency.value}`)}` : "");
        const amountText = computed(() => `${formatMinor(amountMinor.value)}${suffix.value}`);
        const projectLabel = computed(() => projectOptions.value.find((p) => p.projectId === state.projectId)?.label ?? "");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_unref(tf)("payment.summaryDonation")) + " ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_3, "· " + _toDisplayString(frequencyLabel.value), 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(amountText.value), 1 /* TEXT */)
                ]),
                (projectLabel.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(_unref(tf)("payment.summaryProject")), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(projectLabel.value), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(tf)("payment.summaryTotal")), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(amountText.value), 1 /* TEXT */)
                ])
            ]));
        };
    }
});
